import React from 'react'

import clsx from 'clsx'

import Button from 'components/Button'
import Icon from 'components/Icon'
import { useEventContext } from 'context/EventContext'

import classes from './CategoryItem.module.scss'

/** @type {import("./types").default} */
const CategoryItem = ({ category: { title, url, icon }, titleSuffix, className }) => {
  const { addEvent } = useEventContext()

  return (
    <Button
      component="a"
      href={url}
      color="inherit"
      className={clsx('CategoryItem', classes.root, className)}
      data-testid="software-categories-item"
      {...addEvent()}
    >
      <Icon className={clsx('Icon', classes.icon, classes.tealIcon)} icon={icon} size={32} />
      <p className={classes.title}>
        <span>{title}</span> {titleSuffix}
      </p>
    </Button>
  )
}

export default CategoryItem
